import React from 'react';

import ActionFunctionButton from 'notebook/structured-tables/action-functions/ActionFunctionButton';
import makeCustomButtonActionFunction from 'notebook/structured-tables/action-functions/makeCustomButtonActionFunction';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import {ButtonStyle} from 'ui-library/buttons/Button';

/**
 * Toolbar action that opens the table's transposed "pivot mode". It invokes
 * `onEnterPivotMode` (threaded through the action-function params by `StructuredTableView`), which
 * maximizes the table; the structured-table render path shows a maximized pivot-mode table as the
 * transposed grid. For pivot-mode tables this button replaces the default full-screen button.
 *
 * Rendered as a text-only toolbar button (no icon). It only ever lives in the `primary` slot, so it is
 * never asked to render as an overflow menu item.
 */
export const pivotActionFunction = makeCustomButtonActionFunction<{}, {}>({
  // Defensive: hide if the host view didn't wire up pivot-mode entry.
  getHidden: (params) => params.onEnterPivotMode == null,
  renderToolbarButton: (params) => (
    <ActionFunctionButton
      tooltip=""
      tooltipDisabled={true}
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      // A locked table (older version, or no edit permission) can't be edited, so pivot mode is
      // disabled — matching the default full-screen button it replaces.
      disabled={params.locked}
      buttonText="Pivot"
      onClick={() => {
        params.onEnterPivotMode?.();
      }}
    />
  ),
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
});
